
import { isEmpty, cleanObject, fmt, parseDate, getConfig, arrayFrom } from '../twd'

export const getCalcInput = ({cusip, price, priceOrYield='1', yld, qty, action='B', settlement} = {}) => {

    if (!cusip) { return null }

    const py = !isEmpty(priceOrYield) ? String(priceOrYield) : (!isEmpty(yld) ? '0' : '1')
    return cleanObject({
        cusip,
        priceYield: py==='1' ? price : yld,
        priceOrYield: py,
        qty,
        action,
        settlement
    })
}

export const getCalcInputErrors = (bi, ci) => {
    const err = {}
    if (!ci) { return { error: 'empty fields'} }

    if (bi && !bi.canCalc) { return { error: 'cant calc'} }

    const {priceYield, priceOrYield, qty, settlement} = ci

    const py = String(priceOrYield)
    const px = py === '1'  ? parseFloat(priceYield) : NaN
    const ytw = py === '0'  ? parseFloat(priceYield) : NaN
    const ytm = py === '2'  ? parseFloat(priceYield) : NaN

    if (isNaN(px) && isNaN(ytw) && isNaN(ytm)) {
        err.priceYield = py==='1' ? 'Enter price.' : 'Enter yield.'
    }
    else if (!isNaN(px) && px===0) {
        err.priceYield = 'Enter price.'
    }
    else if (!isNaN(px) && (px<=0 || px>999)) {
        err.priceYield = 'Price cannot exceed 999.'
    }
    else if (!isNaN(ytw) && Math.abs(ytw)>999) {
        err.priceYield = 'Yield cannot exceed 999.'
    }
    else if (!isNaN(ytm) && Math.abs(ytm)>999) {
        err.priceYield = 'Yield cannot exceed 999.'
    }

    const issue = (bi && bi.issue) || {}
    const { type, firstSettlement, maturity, minQty, maturityEff } = issue
    const q = parseFloat(qty)
    const incrQty = (type==='M' || type==='A') ? 5 : 1
    if (!q) {
        err.quantity = 'Enter quantity.'
    }
    else if (q<minQty) {
        err.quantity = 'Quantity should be equal or greater than ' + fmt.qty(minQty) + '.'
    }
    else if (q % incrQty !== 0) {
        err.quantity = 'Increment for this bond is ' + fmt.qty(incrQty) + '.'
    }
    else if (q>9999) {
        err.quantity = 'Quantity cannot exceed 9,999.'
    }


    const mat = parseDate(maturity)
    const matEff = parseDate(maturityEff)
    const stl1 = parseDate(firstSettlement)
    const stl = parseDate(settlement)
    const now = Date.now()
    if (!stl) {
        err.settlement = 'Enter date.'
    }
    else if (stl && stl<=now) {
        err.settlement = 'Date must be after today.'
    }
    else if (stl && matEff && stl>=matEff) {
        err.settlement = 'Date cannot exceed Maturity date.'
    }
    else if (stl && mat && stl>=mat) {
        err.settlement = 'Date cannot exceed Maturity date.'
    }
    else if (stl && stl1 && stl<stl1) {
        err.settlement = 'Date must be after first settlement date.'
    }
    else if (stl && arrayFrom(getConfig('next_holiday', [])).indexOf(fmt.mdy(stl))>=0) {
        err.settlement = 'Date must be a business day.'
    }
    else if (stl && arrayFrom(getConfig('working_holiday', [])).indexOf(fmt.mdy(stl))>=0) {
        err.settlement = 'Date must be a business day.'
    }
    else if (stl && [0,6].indexOf(stl.getDay())>=0) {
        err.settlement = 'Date must be a business day.'
    }

    return cleanObject(err)
}

export const isCalcInput = (bi, ci) => {
    return Object.keys(getCalcInputErrors(bi, ci)).length===0
}